export enum ChooseItemSkeletonShapeType {
  Text = 'text',
  Icon = 'icon',
  Avatar = 'avatar',
  Pill = 'pill',
}
